"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var temp = function CloudTwoTone(primaryColor, secondaryColor) {
    return {
        name: 'cloud',
        theme: 'twotone',
        nameWithTheme: 'cloud-twotone',
        tag: 'svg',
        attrs: {
            xmlns: 'http://www.w3.org/2000/svg',
            class: 'icon',
            viewBox: '0 0 1024 1024'
        },
        children: [
            {
                tag: 'path',
                attrs: {
                    fill: secondaryColor,
                    d: 'M791.9 492l-37.8-10-13.8-36.5c-8.6-22.7-20.6-44.1-35.7-63.4-14.9-19.1-32.5-35.9-52.4-49.9-41.1-28.9-89.5-44.2-140-44.2s-98.9 15.3-140 44.2c-19.8 14-37.5 30.7-52.4 49.9-15.1 19.3-27.1 40.6-35.7 63.4l-13.9 36.6-37.9 9.9c-25.9 6.9-49.4 22.4-66.1 43.7-17.1 22-26.2 48.3-26.2 76.3 0 33.1 12.9 64.3 36.3 87.7 23.4 23.4 54.5 36.3 87.6 36.3h496.2c33.1 0 64.2-12.9 87.6-36.3 23.4-23.4 36.3-54.6 36.3-87.7 0-56.2-37.8-105.5-92.1-120z'
                },
                children: []
            },
            {
                tag: 'path',
                attrs: {
                    d: 'M811.4 418.7C765.6 297.9 648.9 212 512.2 212S258.8 297.8 213 418.6C127.3 441.1 64 519.1 64 612c0 110.5 89.5 200 199.9 200h496.2C870.5 812 960 722.5 960 612c0-92.7-63.1-170.7-148.6-193.3zm36.3 281c-23.4 23.4-54.5 36.3-87.6 36.3H263.9c-33.1 0-64.2-12.9-87.6-36.3-23.4-23.4-36.3-54.6-36.3-87.7 0-28 9.1-54.3 26.2-76.3 16.7-21.3 40.2-36.8 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4 14.9-19.2 32.6-35.9 52.4-49.9 41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10c54.3 14.5 92.1 63.8 92.1 120 0 33.1-12.9 64.3-36.3 87.7z',
                    fill: primaryColor
                },
                children: []
            }
        ]
    };
};
temp.nameWithTheme = 'cloud-twotone';
var CloudTwoTone = temp;
exports.default = CloudTwoTone;



//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@1.0.3@@ant-design/icons/lib/twotone/CloudTwoTone.js
// module id = 1064
// module chunks = 0 1